export enum RoleEnum {
  PrecourseUser = 'precourse-user',
  MainCourseUser = 'maincourse-user',
  Mentor = 'mentor',
  Instructor = 'instructor',
  Admin = 'admin',
}
